// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"400":"4705e0d8eab4d281","930":"b27a35ddd16cddaa"}[chunkId] + ".js";
};